import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash;
    const sessionId = hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) { navigate("/auth", { replace: true }); return; }
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.role === "admin" ? "/admin" : "/compte", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/auth", { replace: true }));
  }, []); // eslint-disable-line

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Loader2 className="animate-spin text-ciel" size={32} />
      <p className="text-sm text-slate-500">Connexion en cours…</p>
    </div>
  );
}
